module.exports = __webpack_public_path__ + "img/Boss-1.1861efd4.gif";